import { render } from "./Invoice.vue?vue&type=template&id=28230435"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=28230435&lang=scss"
script.render = render

export default script